/* ==========================================================
   Baby Fair - extras
   1. turns the decorative price bar into a real draggable slider
   2. wishlist (localStorage) + wishlist page renderer
   3. product gallery and full screen viewer arrows
   ========================================================== */
(function () {
  'use strict';

  /* several sections include this file; run it only once per page so every
     click is handled exactly once (a second copy undid wishlist taps) */
  if (window.__bfExtrasLoaded) return;
  window.__bfExtrasLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function isDigit(ch) { return ch >= '0' && ch <= '9'; }
  function num(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  /* =========================================================
     1. PRICE RANGE SLIDER
     The section prints .bf-price-track as two static dots.
     We keep that markup and make it live, so the filter form,
     its query params and the AJAX re-render all keep working.
     ========================================================= */

  /* copy the money shape Liquid already printed, e.g. Tk 1,200.00 */
  function shapeFrom(text) {
    var t = String(text || '');
    var label = 'Price:';
    var c = t.indexOf(':');
    if (c !== -1) { label = t.slice(0, c + 1); t = t.slice(c + 1); }
    var part = t.split(' - ')[0].trim();
    var i = 0;
    while (i < part.length && !isDigit(part.charAt(i))) i++;
    var j = i;
    while (j < part.length && (isDigit(part.charAt(j)) || part.charAt(j) === '.' || part.charAt(j) === ',')) j++;
    var body = part.slice(i, j);
    var dot = body.lastIndexOf('.');
    return {
      label: label,
      pre: part.slice(0, i),
      suf: part.slice(j),
      dec: dot === -1 ? 0 : body.length - dot - 1
    };
  }

  function upgradeTrack(track) {
    var body = track.parentNode;
    if (!body) return;
    var wrap = body.querySelector('.bf-price-inputs');
    if (!wrap) return;
    var ins = wrap.querySelectorAll('input');
    if (ins.length < 2) return;

    var lo = ins[0], hi = ins[1];
    var MIN = num(lo.placeholder);
    var MAX = num(hi.placeholder);
    if (MIN === null) MIN = 0;
    if (MAX === null || MAX <= MIN) return;

    var out = body.querySelector('.bf-price-out');
    var shape = shapeFrom(out ? out.textContent : '');
    function fmt(v) {
      var s;
      try {
        s = Number(v).toLocaleString('en-US', { minimumFractionDigits: shape.dec, maximumFractionDigits: shape.dec });
      } catch (e) {
        s = Number(v).toFixed(shape.dec);
      }
      return shape.pre + s + shape.suf;
    }

    track.classList.add('is-live');
    track.removeAttribute('aria-hidden');

    var dots = track.querySelectorAll('i');
    var h1 = dots[0], h2 = dots[1];
    if (!h1 || !h2) return;

    var fill = document.createElement('span');
    fill.className = 'bf-price-track__fill';
    track.insertBefore(fill, h1);

    h1.setAttribute('data-h', 'min');
    h2.setAttribute('data-h', 'max');
    h1.setAttribute('aria-label', 'Minimum price');
    h2.setAttribute('aria-label', 'Maximum price');
    [h1, h2].forEach(function (h) {
      h.setAttribute('tabindex', '0');
      h.setAttribute('role', 'slider');
      h.setAttribute('aria-valuemin', MIN);
      h.setAttribute('aria-valuemax', MAX);
    });

    var vLo = lo.value !== '' ? num(lo.value) : MIN;
    var vHi = hi.value !== '' ? num(hi.value) : MAX;
    if (vLo === null) vLo = MIN;
    if (vHi === null) vHi = MAX;

    var step = Math.max(1, Math.round((MAX - MIN) / 100));

    function pct(v) { return ((v - MIN) / (MAX - MIN)) * 100; }

    function paint() {
      var a = pct(vLo), b = pct(vHi);
      h1.style.left = a + '%';
      h2.style.left = b + '%';
      fill.style.left = a + '%';
      fill.style.width = Math.max(0, b - a) + '%';
      h1.setAttribute('aria-valuenow', vLo);
      h2.setAttribute('aria-valuenow', vHi);
      if (out) {
        var txt = shape.label + ' ' + fmt(vLo) + ' - ' + fmt(vHi);
        if (out.textContent !== txt) out.textContent = txt;
      }
    }

    function fire(el, type) {
      var ev;
      try { ev = new Event(type, { bubbles: true }); }
      catch (e) { ev = document.createEvent('Event'); ev.initEvent(type, true, true); }
      el.dispatchEvent(ev);
    }

    /* write back into the real form fields; blank at the extremes
       keeps the resulting URL clean */
    function commit(fireChange) {
      lo.value = vLo > MIN ? String(Math.round(vLo)) : '';
      hi.value = vHi < MAX ? String(Math.round(vHi)) : '';
      fire(lo, 'input');
      fire(hi, 'input');
      if (fireChange) { fire(lo, 'change'); fire(hi, 'change'); }
    }

    function valueAt(x) {
      var r = track.getBoundingClientRect();
      var p = (x - r.left) / (r.width || 1);
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      return MIN + p * (MAX - MIN);
    }

    var dragging = null;

    function moveTo(x) {
      var v = Math.round(valueAt(x));
      if (dragging === 'min') vLo = Math.min(v, vHi);
      else vHi = Math.max(v, vLo);
      paint();
    }

    function down(x, target, pointerId) {
      var handle = target && target.closest ? target.closest('i') : null;
      if (handle && handle.getAttribute('data-h')) {
        dragging = handle.getAttribute('data-h');
      } else {
        var v = valueAt(x);
        dragging = Math.abs(v - vLo) <= Math.abs(v - vHi) ? 'min' : 'max';
      }
      (dragging === 'min' ? h1 : h2).classList.add('is-drag');
      if (pointerId != null) { try { track.setPointerCapture(pointerId); } catch (err) {} }
      moveTo(x);
    }
    function move(x) {
      if (!dragging) return;
      moveTo(x);
      commit(false);
    }
    function up(pointerId) {
      if (!dragging) return;
      (dragging === 'min' ? h1 : h2).classList.remove('is-drag');
      dragging = null;
      if (pointerId != null) { try { track.releasePointerCapture(pointerId); } catch (err) {} }
      commit(true);
    }

    if (window.PointerEvent) {
      track.addEventListener('pointerdown', function (e) { e.preventDefault(); down(e.clientX, e.target, e.pointerId); });
      track.addEventListener('pointermove', function (e) { if (dragging) { e.preventDefault(); move(e.clientX); } });
      track.addEventListener('pointerup', function (e) { up(e.pointerId); });
      track.addEventListener('pointercancel', function (e) { up(e.pointerId); });
    } else {
      track.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX, e.target, null); });
      document.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX); });
      document.addEventListener('mouseup', function () { up(null); });
      track.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        e.preventDefault();
        down(t.clientX, e.target, null);
      }, { passive: false });
      track.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        move(e.touches[0].clientX);
      }, { passive: false });
      track.addEventListener('touchend', function () { up(null); });
      track.addEventListener('touchcancel', function () { up(null); });
    }

    [h1, h2].forEach(function (h) {
      h.addEventListener('keydown', function (e) {
        var d = 0;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') d = -step;
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') d = step;
        else if (e.key === 'Home') d = -(MAX - MIN);
        else if (e.key === 'End') d = MAX - MIN;
        else return;
        e.preventDefault();
        if (h.getAttribute('data-h') === 'min') vLo = Math.max(MIN, Math.min(vLo + d, vHi));
        else vHi = Math.min(MAX, Math.max(vHi + d, vLo));
        paint();
        commit(true);
      });
    });

    /* typing in the boxes moves the handles */
    function pull() {
      var a = lo.value !== '' ? num(lo.value) : MIN;
      var b = hi.value !== '' ? num(hi.value) : MAX;
      if (a === null) a = MIN;
      if (b === null) b = MAX;
      vLo = Math.max(MIN, Math.min(a, MAX));
      vHi = Math.max(MIN, Math.min(b, MAX));
      if (vLo > vHi) vLo = vHi;
      paint();
    }
    lo.addEventListener('input', function () { if (!dragging) pull(); });
    hi.addEventListener('input', function () { if (!dragging) pull(); });

    paint();
  }

  function scanTracks(ctx) {
    $$('.bf-price-track:not(.is-live)', ctx || document).forEach(function (t) {
      try { upgradeTrack(t); } catch (e) {}
    });
  }

  /* =========================================================
     2. WISHLIST
     ========================================================= */

  var WKEY = 'bf_wishlist';

  function wlRead() {
    try {
      var a = JSON.parse(window.localStorage.getItem(WKEY));
      return Object.prototype.toString.call(a) === '[object Array]' ? a : [];
    } catch (e) { return []; }
  }
  function wlSave(a) {
    try { window.localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {}
  }
  function wlWrite(a) { wlSave(a); paintWishlist(); }
  function wlHas(h) { return wlRead().indexOf(h) !== -1; }
  function wlToggle(h) {
    var a = wlRead(), i = a.indexOf(h);
    if (i === -1) a.unshift(h); else a.splice(i, 1);
    wlWrite(a);
    return i === -1;
  }

  function handleFromUrl(u) {
    var s = String(u || '').split('?')[0].split('#')[0];
    var i = s.indexOf('/products/');
    if (i === -1) return '';
    var rest = s.slice(i + 10).split('/')[0];
    return rest ? decodeURIComponent(rest) : '';
  }
  function handleFor(btn) {
    var h = btn.getAttribute('data-bf-wish');
    if (h) return h;
    var scope = btn.closest('[data-bf-cell], .bf-pcard, .bf-wlc, .bf-buy, form');
    var a = scope && scope.querySelector('a[href*="/products/"]');
    if (a) {
      h = handleFromUrl(a.getAttribute('href'));
      if (h) return h;
    }
    return handleFromUrl(window.location.pathname);
  }

  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bf-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  function paintWishlist() {
    var list = wlRead();
    var n = String(list.length);
    $$('[data-bf-wish-count]').forEach(function (el) {
      if (el.textContent !== n) el.textContent = n;
      if (el.hidden) el.hidden = false;
    });
    $$('[data-bf-wish], .bf-atc__wish').forEach(function (b) {
      var h = handleFor(b);
      var on = !!h && list.indexOf(h) !== -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var x = t.closest('[data-bf-wish-remove]');
    if (x) {
      e.preventDefault();
      var rh = x.getAttribute('data-bf-wish-remove');
      var a = wlRead(), i = a.indexOf(rh);
      if (i !== -1) { a.splice(i, 1); wlWrite(a); }
      var card = x.closest('.bf-wlc, [data-bf-wl-cell]');
      if (card && card.hasAttribute('data-bf-wl-cell')) {
        dropCell(card);
      } else if (card) {
        card.style.transition = 'opacity .18s ease, transform .18s ease';
        card.style.opacity = '0';
        card.style.transform = 'scale(.96)';
        setTimeout(function () {
          if (card.parentNode) card.parentNode.removeChild(card);
          if (!wlRead().length) renderWishlistPage();
        }, 190);
      } else {
        renderWishlistPage();
      }
      toast('Removed from wishlist');
      return;
    }

    var b = t.closest('[data-bf-wish], .bf-atc__wish');
    if (!b) return;
    e.preventDefault();
    var h = handleFor(b);
    if (!h) { toast('Open the product page to save it'); return; }
    var on = wlToggle(h);
    b.classList.toggle('is-on', on);
    if (!on) {
      var cell = b.closest('[data-bf-wl-cell]');
      if (cell) dropCell(cell);
    }
    b.classList.remove('is-pop');
    void b.offsetWidth;
    b.classList.add('is-pop');
    toast(on ? 'Added to your wishlist' : 'Removed from wishlist');
  });

  /* ---------- wishlist page ---------- */

  function money(cents) {
    var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: c, minimumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split("'").join('&#39;');
  }
  function sized(url, size) {
    var s = String(url || ''), q = '';
    var qi = s.indexOf('?');
    if (qi !== -1) { q = s.slice(qi); s = s.slice(0, qi); }
    var d = s.lastIndexOf('.');
    if (d === -1) return url;
    return s.slice(0, d) + '_' + size + s.slice(d) + q;
  }

  function cardHTML(p, handle) {
    var url = ROOT + 'products/' + handle;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var media = img
      ? '<img src="' + esc(sized(img, '600x')) + '" alt="' + esc(p.title) + '" loading="lazy">'
      : '<span class="bf-wlc__ph">Image coming soon</span>';
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var multi = p.variants && p.variants.length > 1;
    var first = p.variants && p.variants[0];
    var cta;
    if (!p.available) {
      cta = '<button type="button" class="bf-wlc__cta" disabled>Sold Out</button>';
    } else if (multi) {
      cta = '<a class="bf-wlc__cta" href="' + esc(url) + '">Select Options</a>';
    } else {
      cta =
        '<form class="bf-wlc__form" action="' + esc(ROOT + 'cart/add') + '" method="post" enctype="multipart/form-data">' +
        '<input type="hidden" name="id" value="' + esc(first ? first.id : '') + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="bf-wlc__cta">Add To Cart</button>' +
        '</form>';
    }
    return '<article class="bf-wlc">' +
      '<a class="bf-wlc__media" href="' + esc(url) + '">' + media + '</a>' +
      '<button type="button" class="bf-wlc__x" data-bf-wish-remove="' + esc(handle) + '" aria-label="Remove from wishlist">&times;</button>' +
      '<div class="bf-wlc__body">' +
      '<a class="bf-wlc__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
      '<p class="bf-wlc__price"><ins>' + money(p.price) + '</ins>' +
      (sale ? '<del>' + money(p.compare_at_price) + '</del>' : '') + '</p>' +
      cta +
      '</div>' +
      '</article>';
  }

  /* ---------- wishlist page: same cards as the shop page ----------
     each product card comes from /products/<handle>?section_id=babyfair-card-render
     and is cached, so the next visit paints instantly with no loading text */

  var CKEY = 'bf_wishlist_cards';
  function cardCache() {
    try { var c = JSON.parse(window.localStorage.getItem(CKEY)); return c && typeof c === 'object' ? c : {}; }
    catch (e) { return {}; }
  }
  function cardCacheSave(c) {
    try { window.localStorage.setItem(CKEY, JSON.stringify(c)); } catch (e) {}
  }

  function cellHTML(handle, inner) {
    /* the card's own heart (already filled) removes it, exactly like the shop page */
    return '<div class="bf-cgrid__cell" data-bf-wl-cell data-handle="' + esc(handle) + '">' + inner + '</div>';
  }

  function paintCount(n) {
    var bar = $('[data-bf-wl-bar]');
    var c = $('[data-bf-wl-count]');
    if (c) c.textContent = String(n);
    if (bar) bar.hidden = !n;
  }

  function showEmpty(grid, empty) {
    grid.innerHTML = '';
    grid.hidden = true;
    if (empty) empty.hidden = false;
    paintCount(0);
  }

  function dropCell(cell) {
    cell.style.opacity = '0';
    cell.style.transform = 'scale(.96)';
    setTimeout(function () {
      if (cell.parentNode) cell.parentNode.removeChild(cell);
      var grid = $('[data-bf-wishgrid]');
      if (!grid) return;
      var left = grid.querySelectorAll('[data-bf-wl-cell]').length;
      paintCount(left);
      if (!left) showEmpty(grid, $('[data-bf-wishempty]'));
    }, 190);
  }

  function fetchCard(h) {
    return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?section_id=babyfair-card-render', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-bf-card-render]');
        if (!node || !node.querySelector('.bf-pcard')) return null;
        return node.innerHTML.trim();
      })
      .catch(function () { return undefined; });
  }

  var renderToken = 0;
  function renderWishlistPage() {
    var grid = $('[data-bf-wishgrid]');
    if (!grid) return;
    var empty = $('[data-bf-wishempty]');
    var handles = wlRead();
    var token = ++renderToken;

    if (!handles.length) { showEmpty(grid, empty); return; }
    if (empty) empty.hidden = true;

    /* 1. paint whatever we already have, straight away */
    var cache = cardCache();
    var html = '';
    handles.forEach(function (h) { if (cache[h]) html += cellHTML(h, cache[h]); });
    if (html) {
      grid.innerHTML = html;
      grid.hidden = false;
      paintCount(handles.length);
      paintWishlist();
    }

    /* 2. refresh from the store (prices, stock and new items) */
    Promise.all(handles.map(fetchCard)).then(function (cards) {
      if (token !== renderToken) return;
      var out = '', alive = [], fresh = {};
      cards.forEach(function (card, i) {
        var h = handles[i];
        if (card === undefined && cache[h]) card = cache[h];   /* network hiccup: keep the old card */
        if (!card) return;                                      /* product deleted or hidden */
        alive.push(h);
        fresh[h] = card;
        out += cellHTML(h, card);
      });
      cardCacheSave(fresh);
      if (alive.length !== handles.length) wlSave(alive);
      if (!out) { showEmpty(grid, empty); return; }
      grid.innerHTML = out;
      grid.hidden = false;
      if (empty) empty.hidden = true;
      paintCount(alive.length);
      paintWishlist();
    });
  }

  document.addEventListener('click', function (e) {
    var c = e.target && e.target.closest && e.target.closest('[data-bf-wl-clear]');
    if (!c) return;
    e.preventDefault();
    wlWrite([]);
    var grid = $('[data-bf-wishgrid]');
    if (grid) showEmpty(grid, $('[data-bf-wishempty]'));
    toast('Wishlist cleared');
  });

  /* =========================================================
     3. PRODUCT GALLERY ARROWS
     Added from here so the product section markup stays untouched.
     ========================================================= */

  var SVG_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="m14.5 5-7 7 7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="m9.5 5 7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function arrowBtn(cls, label, svg) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = svg;
    return b;
  }

  /* move one full frame, wrapping round at either end */
  function slideBy(el, dir) {
    var w = el.clientWidth || 1;
    var max = el.scrollWidth - w;
    var count = Math.max(1, Math.round(el.scrollWidth / w));
    var next = Math.round(el.scrollLeft / w) + dir;
    if (next < 0) next = count - 1;
    if (next > count - 1) next = 0;
    el.scrollTo({ left: Math.min(max, next * w), behavior: 'smooth' });
  }

  function setupGalleryArrows() {
    $$('[data-bf-gal]').forEach(function (gal) {
      if (gal.getAttribute('data-bf-arw') === '1') return;
      if (gal.querySelectorAll('[data-bf-gal-item]').length < 2) return;
      gal.setAttribute('data-bf-arw', '1');

      var wrap = document.createElement('div');
      wrap.className = 'bf-galwrap';
      gal.parentNode.insertBefore(wrap, gal);
      wrap.appendChild(gal);

      var prev = arrowBtn('bf-galarw bf-galarw--prev', 'Previous image', SVG_L);
      var next = arrowBtn('bf-galarw bf-galarw--next', 'Next image', SVG_R);
      wrap.appendChild(prev);
      wrap.appendChild(next);

      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); slideBy(gal, -1); });
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); slideBy(gal, 1); });

      /* only meaningful while the gallery actually scrolls sideways,
         which is the mobile carousel - the desktop grid never does */
      function sync() { wrap.classList.toggle('is-live', gal.scrollWidth - gal.clientWidth > 4); }
      sync();
      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      gal.addEventListener('scroll', sync, { passive: true });
    });
  }

  function setupLightboxArrows() {
    $$('[data-bf-lb]').forEach(function (lb) {
      if (lb.getAttribute('data-bf-arw') === '1') return;
      var track = lb.querySelector('[data-bf-lb-track]');
      if (!track || track.querySelectorAll('.bf-lb__item').length < 2) return;
      lb.setAttribute('data-bf-arw', '1');

      var prev = arrowBtn('bf-lbarw bf-lbarw--prev', 'Previous image', SVG_L);
      var next = arrowBtn('bf-lbarw bf-lbarw--next', 'Next image', SVG_R);
      lb.appendChild(prev);
      lb.appendChild(next);

      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); slideBy(track, -1); });
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); slideBy(track, 1); });

      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); slideBy(track, -1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); slideBy(track, 1); }
      });
    });
  }

  /* =========================================================
     boot, and re-run after AJAX section swaps
     ========================================================= */
  function boot() {
    scanTracks(document);
    setupGalleryArrows();
    setupLightboxArrows();
    paintWishlist();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  var pending = null;
  if (window.MutationObserver) {
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var added = recs[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          /* elements only: text updates from paintWishlist must not re-trigger us */
          if (added[j].nodeType === 1) {
            clearTimeout(pending);
            pending = setTimeout(function () {
              scanTracks(document);
              setupGalleryArrows();
              setupLightboxArrows();
              paintWishlist();
            }, 90);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', boot);

  window.BFWishlist = { read: wlRead, has: wlHas, toggle: wlToggle, render: renderWishlistPage };
})();
